import { Button, Modal } from "antd";
import "./style.scss";

type Props = {
  onDelete: () => void;
  onCloseModal: () => void;
  title?: string;
  loading?: boolean;
  provider: {
    logoUrl: string;
    name: {
      en: string;
      ar?: string;
    };
  };
};

export const DeleteConfirmation = ({
  title,
  loading,
  provider,
  onDelete,
  onCloseModal,
}: Props) => {
  if (!provider) return;

  return (
    <Modal className="delete-provider-modal" open closable={false}>
      <h2>Delete {title || "Providers"}</h2>
      <p>
        Are you sure do you want to delete this {title || "provider"}, this
        action can’t be undone.
      </p>
      <div className="provider-details-details">
        <span>
          <img
            src={provider.logoUrl}
            alt="logo-url"
            onError={(e) => {
              (e.target as HTMLImageElement).src =
                "/assets/providers/mokhtabar.png";
            }}
          />
        </span>
        <p>{provider.name.en}</p>
      </div>
      <div className="modal-action">
        <Button loading={loading} onClick={onDelete} type="primary">
          Delete
        </Button>
        <Button onClick={onCloseModal} type="default">
          Cancel
        </Button>
      </div>
    </Modal>
  );
};
